import { render, staticRenderFns } from "./actWorkView copy.vue?vue&type=template&id=56ae948d&"
import script from "./actWorkView copy.vue?vue&type=script&lang=js&"
export * from "./actWorkView copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports